import { z } from "zod";

export const requiredStringSchema = () =>
  z.string().min(1, { message: "This field is required" });
